/**
 * Rotate Vista hub tile hero images (vanilla JS, jQuery 1.4.2 safe).
 */
(function () {
  var tiles = document.querySelectorAll(
    '.vista-hub-tile[data-hero-interval], .vista-segment-hero[data-hero-interval]'
  );
  if (!tiles.length) {
    return;
  }
  var reducedMotion = false;
  try {
    reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function activateSlide(imgs, index) {
    var i;
    for (i = 0; i < imgs.length; i++) {
      if (i === index) {
        imgs[i].className = 'vista-hub-slide-active';
      } else {
        imgs[i].className = '';
      }
    }
  }

  for (var t = 0; t < tiles.length; t++) {
    (function (tile) {
      var wrap =
        tile.querySelector('.vista-hub-tile-image') ||
        tile.querySelector('.vista-segment-hero-gallery');
      if (!wrap) {
        return;
      }
      var imgs = wrap.getElementsByTagName('img');
      if (imgs.length < 2 || reducedMotion) {
        if (imgs.length) {
          imgs[0].className = 'vista-hub-slide-active';
        }
        return;
      }
      var interval = parseInt(tile.getAttribute('data-hero-interval'), 10) || 5000;
      var idx = 0;
      activateSlide(imgs, 0);
      setInterval(function () {
        idx = (idx + 1) % imgs.length;
        activateSlide(imgs, idx);
      }, interval);
    })(tiles[t]);
  }
})();
